export const UPDATECARDS = 'UPDATECARDS';

export const UPDATEPLANDETAILS = 'UPDATEPLANDETAILS';